import { ListRenderer } from '@feast-it/ui/light';
import React, { ReactElement } from 'react';

import { FooterSocialLink } from '../Footer';
import {
  Area,
  SocialLinkItem,
  SocialLinks,
  StyledIconSocial,
} from '../Footer.styled';
import { useIsDarkTheme } from '../../../context/DarkThemeContext';

interface SocialLinksListProps {
  socialLinks: FooterSocialLink[];
}

export function SocialLinksList({
  socialLinks,
}: SocialLinksListProps): ReactElement {
  const isDark = useIsDarkTheme();
  return (
    <Area name="newsletter">
      <SocialLinks>
        <ListRenderer
          items={socialLinks}
          render={({ item }) => (
            <SocialLinkItem>
              <a href={item.href} aria-label={item.type}>
                <StyledIconSocial
                  name={item.type}
                  size={36}
                  fill={isDark ? 'white' : 'black'}
                />
              </a>
            </SocialLinkItem>
          )}
        />
      </SocialLinks>
    </Area>
  );
}
